<template>
  <div
    class="dui-editor-toolbar ql-toolbar"
    :style="{ top: toolbarFixedTop + 'px',
              width: toolbarWidth + 'px' }"
  >
    <div class="toolbar-button-group">
      <button
        v-for="(option, index) in options"
        :key="index"
        :class="option.class"
        :format="option.format"
        type="button"
      >
        {{ option.name }}
      </button>
    </div>

    <div
      v-if="displayWordCount"
      class="word-count"
    >
      Wordcount {{ wordCount }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    displayWordCount: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    toolbarFixedTop: {
      type: Number,
      default: null,
    },
    toolbarWidth: {
      type: Number,
      default: null,
    },
    wordCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-editor .dui-editor-toolbar.ql-snow {
  align-items: center;
  background-color: getColor($white);
  border-bottom-color: getColor($grey);
  border-style: solid;
  border-top: none;
  border-width: $border-width-lg 0;
  display: flex;
  padding: $_1-5em 0 0;

  .toolbar-button-group {
    flex: 1;
  }

  .word-count {
    color: getColor($grey, dark);
    flex: 0 1 auto;
    font-size: $font-size-sm;
    text-transform: uppercase;
  }
}
</style>
